import { motion } from 'framer-motion';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

function BuyNowBtn() {
   const styleBtn = {
      zIndex: 999999,
      position: 'fixed',
      top: '2.5rem',
      right: '-.8rem',
      borderRadius: '0',
      borderRight: '0',
      paddingRight: '2rem',
      fontSize: '1.3rem',
   };

   return (
      <motion.a
         href="https://airbnb.com/h/kampchristy"
         className="badge pulse"
         style={styleBtn}
         target="_blank"
         rel="noopener noreferrer"

         initial={{ opacity: 0, x: '100%' }}
         animate={{ opacity: 1, x: 0 }}
         transition={{ duration: .8, ease: 'easeIn' }}
      >
         <span style={{ marginLeft: '.5rem' }}>airbnb</span>
      </motion.a>
   );
}

export default BuyNowBtn;